import { render } from "./HeaderApp.vue?vue&type=template&id=5c653c11&scoped=true"
import script from "./HeaderApp.vue?vue&type=script&lang=js"
export * from "./HeaderApp.vue?vue&type=script&lang=js"

import "@/assets/css/Header.css?vue&type=style&index=0&id=5c653c11&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c653c11"]])

export default __exports__